import React, { useState, useEffect } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";

import background from "../Assets/collection4.jpg";
import product1 from "../Assets/product2.jpeg";
import product2 from "../Assets/product1.jpeg";
import product3 from "../Assets/product3.jpg";
// Import 3 more different images (you need to add these to your Assets folder)
import product4 from "../Assets/product4.jfif"; // Add this image
import product5 from "../Assets/product5.jpg"; // Add this image
import product6 from "../Assets/product7.jpg"; // Add this image
import gold from "../Assets/gold.jpeg";
import silver from "../Assets/silver.jpeg";
import wedding from "../Assets/wedding4.jpg";
import background3 from "../Assets/background4.jpg";

const Home = () => {
    const navigate = useNavigate();
    const [showFirstSet, setShowFirstSet] = useState(true);

    // Two sets of images
    const imageSet1 = [product1, product2, product3];
    const imageSet2 = [product4, product5, product6];

    // Auto-alternate between image sets every 4 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setShowFirstSet((prev) => !prev);
        }, 4000); // Change sets every 4 seconds

        return () => clearInterval(interval);
    }, []);

    // Current images to display
    const currentImages = showFirstSet ? imageSet1 : imageSet2;

    // 🔝 Scroll to top + navigate
    const goToPage = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    };

    return (
        <div className="home">
            {/* 🌟 Hero Section */}
            <section className="hero-section">
                <img src={background} alt="Jewellery Background" className="hero-image" />
                <div className="hero-text">
                    <h1>
                        <span className="line1">DEWALEGAMA</span><br />
                        <span className="line2">JEWELLERS</span>
                    </h1>
                    <p>Elegance • Quality • Perfection</p>
                </div>
            </section>

            {/* 🌸 Jewellery Collection Section */}
            <section className="jewellery-collection">
                <h2>Classic Creations</h2>
                <div className="collection-container">
                    {currentImages.map((img, index) => (
                        <div className="collection-image-item" key={index}>
                            <img src={img} alt={`Jewellery ${index + 1}`} className="collection-image" />
                        </div>
                    ))}
                </div>
                
                {/* See More Button */}
                <button className="see-more-btn" onClick={() => goToPage("/category")}>
                    See More
                </button>
            </section>

            {/* 🪞 Shop Introduction Section */}
            <section className="intro-section">
                <div className="intro-card">
                    <div className="intro-content">
                        <div className="intro-text">
                            <h2>Discover Timeless Elegance</h2>
                            <p>
                                At Dewalegama Jewellers, we are devoted to crafting timeless pieces
                                that combine modern artistry with traditional craftsmanship. Each
                                creation tells a story — of love, strength, and heritage — meticulously
                                designed to reflect the elegance and individuality of those who wear them.
                                <br /><br />
                                From intricately detailed necklaces to delicately designed rings, our
                                collection embodies precision and perfection. Whether it's a statement
                                piece for your special day or an everyday treasure, each item is made
                                with care, passion, and authenticity.
                                <br /><br />
                                Our gold, silver, and wedding collections are designed not just to adorn,
                                but to inspire — to become a part of your legacy for generations.
                            </p>

                            <button className="about-btn" onClick={() => goToPage("/about")}>
                                About Us
                            </button>
                        </div>

                        <div className="intro-image">
                            <img src={background3} alt="Jewellery Display" />
                        </div>
                    </div>
                </div>
            </section>

            {/* 💎 Our Collection Section */}
            <section className="our-collection">
                <h2>Our Collections</h2>
                <div className="collection-images">
                    <div className="collection-item">
                        <img src={gold} alt="Gold Collection" />
                        <p>Gold Collection</p>
                        <button onClick={() => goToPage("/gold")}>See More</button>
                    </div>

                    <div className="collection-item">
                        <img src={silver} alt="Silver Collection" />
                        <p>Silver Collection</p>
                        <button onClick={() => goToPage("/silver")}>See More</button>
                    </div>

                    <div className="collection-item">
                        <img src={wedding} alt="Wedding Collection" />
                        <p>Wedding & Engagement</p>
                        <button onClick={() => goToPage("/wedding")}>See More</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;